import BaseModel from '../Base';
import Membership from './Membership';
import Topic from '@/models/strategy/Topic';

export default class Group extends BaseModel {
  static entity = 'groups';

  static fields() {
    return {
      ...super.fields(),
      name: this.string(''),
      slug: this.string('')
    };
  }

  get members() {
    const members = [];

    Membership.query()
      .with('user')
      .all()
      .map(member => {
        if (member.groups_collection.includes(this.id)) {
          members.push(member);
        }
      });

    return members;
  }

  get topics() {
    const topics = [];

    Topic.query()
      .all()
      .map(topic => {
        if (topic.groups_collection.includes(this.id)) {
          topics.push(topic);
        }
      });

    return topics;
  }
}
